import React from 'react';
import { FolderViewModel, IMediaFoldersView } from "../../type/media-hub.types";
import { CameraOutlined } from "@ant-design/icons";
import MediaFolderCover from "./media-folder-cover";
import { useNavigate, useParams } from "react-router-dom";
import { replaceSpaceWithHyphen } from "../../../../utility/utility";
import LoadingSkeleton from "../../../common/loading-skeleton/loading-skeleton";

const MediaFoldersView: React.FC<IMediaFoldersView> = (props) => {

    const navigate = useNavigate();
    const {tabName} = useParams();

    function handleNavigationToImages(eventFolderId: string, eventFolderName: string) {
        const eventName = replaceSpaceWithHyphen(eventFolderName).toLowerCase();
        navigate(`${tabName}/${eventName}`, {
            state: {eventId: eventFolderId, eventName: eventFolderName},
        });
    }

    return (
        <LoadingSkeleton loading={props.isLoading}>
            <div className={'media-folder-container'}>
                <div className={'media-folder-container__list'}>

                    {props.data.map((item: FolderViewModel) => {
                        const date = item.endDate ? (`${item.startDate} - ${item.endDate}`) : item.startDate


                        return (<div className={'media-folder-container__list-item'} key={item.id}
                                     onClick={() => handleNavigationToImages(item.id, item.name)}
                            >
                                <MediaFolderCover
                                    type={item.type}
                                    profilePhoto={item.profilePhoto}
                                    coverImage={item.coverImage}
                                    className={'media-folder-container__cover-image'}
                                />
                                <h3 className={'media-folder-container__title'}>{item.name}</h3>
                                <div className={'media-folder-container__details'}>
                            <span className={'media-folder-container__count'}>
                                <CameraOutlined/>
                                {item.photoCount}{' '}Photos</span>
                                    <span
                                        className={'media-folder-container__date'}>{date}</span>
                                </div>
                            </div>
                        )
                    })}

                </div>
            </div>
        </LoadingSkeleton>
    )
}

export default MediaFoldersView;


